import firebase from 'firebase/app'
import 'firebase/firestore'

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyDUiS5TiTMCeo4_eZDzwhZeDNyBQCJF6fA",
    authDomain: "learnshala-5f8a5.firebaseapp.com",
    databaseURL: "https://learnshala-5f8a5.firebaseio.com",
    projectId: "learnshala-5f8a5",
    storageBucket: "learnshala-5f8a5.appspot.com",
    messagingSenderId: "392083812721",
    appId: "1:392083812721:web:01c993c17d48488df146d0",
    measurementId: "G-3S8MKJDQ2L"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();

const db = firebase.firestore();

// db.settings({ timestampsInSnapshots: true });

export default db;